export default "__VITE_ASSET__BW1I5J24__"